import $ from 'jquery';

const defaults = {
  linksWrapper: undefined,
  parent: undefined,
  original: undefined,
  originalWrapper: undefined,
  hasAnchor: undefined,
};

function LinksGen(element, options) {
  this.$element = $(element);
  this.settings = Object.assign(defaults, options);
  this.init();
}

LinksGen.prototype = {
  init() {
    this.$element
      .find(this.settings.parent)
      .prepend(`<div class="${this.settings.linksWrapper}"><ul class="links"></ul></div>`);
    this.$element.find(this.settings.originalWrapper).each((i, elem) => {
      const target = $(elem).find(this.settings.original);
      const targetLabel = $(target).text();
      let listItem;
      if (this.settings.hasAnchor) {
        const targetUrl = $(target).attr('href');
        listItem = `<li><a href="${targetUrl}">${targetLabel}</a></li>`;
      } else {
        listItem = `<li>${targetLabel}</li>`;
      }
      this.$element.find(`.${this.settings.linksWrapper} .links`).append(listItem);
    });
  },
};

export default LinksGen;
